export default {
  emissionCheck_unit: "Unidad",
  emissionCheck_edit: "Editar",
  emissionCheck_scan: "Escanear",
  emissionCheck_delete: "Eliminar",
  emissionCheck_vehicle: "Vehículo",
  emissionCheck_vin: 'VIN',
  emissionCheck_status: 'Estado',
  emissionCheck_lastScanDate: 'Fecha de la última exploración',
  emissionCheck_lastScanStatus: 'Estado de la última exploración',
  emissionCheck_nextDeadline: 'Próximo plazo',
  emissionCheck_viewEvents: 'Ver eventos',
  emissionCheck_import: 'Importar',
  emissionCheck_export: 'Exportar',
  emissionCheck_advancedFilters: "Filtros Avanzados",
  emissionCheck_clearFilters: "Limpiar Filtros",
  emissionCheck_all: "All",
  emissionCheck_notRegistered: "No registrado",
  emissionCheck_waiting: "En espera",
  emissionCheck_compliant: "Conforme",
  emissionCheck_notCompliant: "No conforme",
  emissionCheck_requested: "Solicitado",
  emissionCheck_complete: "Completado",
  emissionCheck_submitted: "Enviado",
  emissionCheck_pass: "Paso",
  emissionCheck_fail: "Falló",
  emissionCheck_error: "Error",
  emissionCheck_scanDate: "Fecha Escaneo",
  emissionCheck_registerDate: "Fecha Registro",
  emissionCheck_tags: "Etiquetas",
  emissionCheck_viewError: "Ver Error",
  emissionCheck_hideError: "Ocultar Error",
  emissionCheck_deleteTitle: "Dar de baja control de emisiones",
  emissionCheck_deleteConfirm: "Está seguro de que quiere dar de baja el vehículo o vehículos?",
  emissionCheck_editVehicle: "Editar Vehículo",
  emissionCheck_registerVehicle: "Registrar Vehículo",
  emissionCheck_addedSuccessfully: 'El control de emisiones se creó correctamente',
  emissionCheck_updatedSuccessfully: 'El control de emisiones se actualizó correctamente',
  emissionCheck_deleteSuccessfully: 'El control de emisiones se eliminó correctamente',
  emissionCheck_scanEventsSuccessfully: 'Eventos cargados exitosamente. Haga clic en este mensaje para ver los eventos cargados',
  emissionCheck_scanEventsError: 'Eventos no cargados',
  emissionCheck_download_file: 'Descargar archivo adjunto',
  emissionCheck_eventsResume: 'Resumen de eventos cargados',
  emissionCheck_search: "Buscar por Vehículo o VIN",
  emissionCheck_template: "Descargar formato",
  emissionCheck_template_file: "Descargar la lista actual de activos",
  emissionCheck_descriptonImport: "Importar por archivo csv",
  emissionCheck_semicolon: 'Punto y coma',
  emissionCheck_comma: 'Coma',
  emissionCheck_error_required: "El archivo csv es requerido",
  emissionCheck_file: "Archivo",
  emissionCheck_upload: "Cargar",
  emissionCheck_aceept_file: "Solo se aceptan archivos csv",
  emissionCheck_delimiter: "Delimitador",
  emissionCheck_regState: "Estado del Registro",
  emissionCheck_regCountry: "País del Registro",
  emissionCheck_regExpDate: "Fecha de expiración del Registro",
  emissionCheck_enrolled: "Inscrita",
  emissionCheck_error: 'Error',
  emissionCheck_error_delimiter: "Error en el archivo, por favor confirma el delimitador",
  emissionCheck_error_data_required: "Todos los campos son requeridos",
  emissionCheck_error_data_repeat_file: "VIN está repetido",
  emissionCheck_error_regState_long: "Estado del Registro son 2 carácteres",
  emissionCheck_error_regCountry_long: "País del Registro son 3 carácteres",
  emissionCheck_error_vin_chars: 'VIN son 17 carácteres',
  emissionCheck_error_fix: "Por favor corregir los errores antes de continuar",
  emissionCheck_error_started: "La importacion se inicio correctamente,en un momento te indicaremos cuando termine",
  emissionCheck_error_enrolled: "Inscrita debe ser TRUE o FALSE",
  emissionCheck_error_RegExpDate: "Fecha de expiración del Registro no es válida",
  emissionCheck_error_import: "Ocurrió un error desconocido en la importación",
  emissionCheck_result_import: "Resultado de la importación",
  emissionCheck_result_import_fail: "La importación no fue exitosa, revise todos los datos debido a que si alguno tiene error no importara correctamente",
  emissionCheck_result: "Resultado",
  emissionCheck_field: "CAMPO",
  emissionCheck_requirements: "REQUISITOS",
  emissionCheck_text_import_head: "Para empezar, descárgate nuestra útil plantilla.",
  emissionCheck_vin_requirements: 'Longitud fija: 17 caracteres',
  emissionCheck_regState_requirements: "Abreviatura de estado de 2 caracteres ejemplo: «CA» para California",
  emissionCheck_regCountry_requirements: "Formato de país iso3 de 3 caracteres ejemplo: 'USA'",
  emissionCheck_regExpDate_requirements: "Formato de fecha ISO aaaa-mm-dd ejemplo: '2024-10-31'",
  emissionCheck_enrolled_requirements: "Establézcalo en «FALSE» para anular la matriculación del vehículo",
  emissionCheck_text_import_foot: "Las aplicaciones de hojas de cálculo como Google Sheets o Microsoft Excel pueden mostrar las fechas en un formato diferente, como mm/dd/aaaa. Consulta la ayuda o la documentación de tu aplicación para saber cómo cambiar los formatos de fecha."
}